<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="user">
            <ValidationObserver ref="userform">
                <form @submit.prevent="saveUser">
                    <div class="row">
                        <div class="col-xl-10">
                            <div class="row mb-2">
                                <label class="col-form-label col-xl-2"></label>
                                <div class="col-xl-10" style="padding-top: calc(0.4375rem + 1px);">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input id="chk-isActive" type="checkbox" class="custom-control-input" v-model="user.isActive" :true-value="1" :false-value="0">
                                            <label for="chk-isActive" class="custom-control-label">Användaren är aktiv</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <label class="col-form-label col-xl-2"></label>
                                <div class="col-xl-10">
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input id="chk-Visible" type="checkbox" class="custom-control-input" v-model="user.Visible" :true-value="1" :false-value="0">
                                            <label for="chk-Visible" class="custom-control-label">Användaren är synlig i listor</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Användarnamn:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="UserLogin" name="Användarnamn" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.UserLogin" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Namn: <span class="text-danger">*</span></label>
                                <ValidationProvider tag="div" class="col-xl-5" vid="FirstName" name="Förnamn" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.FirstName" placeholder="Förnamn" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider tag="div" class="col-xl-5" vid="LastName" name="Efternamn" rules="required" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.LastName" placeholder="Efternamn" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Namn (gammalt fält):</label>
                                <div class="col-xl-10">
                                    <div class="form-group">
                                        <input type="text" class="form-control" :value="user.FullName" disabled>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">E-post (arbete):</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="email" name="E-post" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.email" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        <div class="text-muted">*Krävs för inloggning i systemen</div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Telefon (arbete):</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="Phone" name="E-post" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.Phone" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Telefon 2 (arbete):</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="phone_2" name="Telefon" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.phone_2" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Timecarekod:</label>
                                <ValidationProvider tag="div" class="col-xl-10" vid="UserTimeCareCode" name="Timecarekod" rules="" v-slot="{ errors }">
                                    <div class="form-group">
                                        <input type="text" class="form-control" v-model="user.UserTimeCareCode" v-bind:class="{ 'border-danger':errors[0] }">
                                        <span class="validation-invalid-label">{{ errors[0] }}</span>
                                        <div class="text-muted">*Krävs för tidregistrering</div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <label class="col-form-label col-xl-2">Sortering i listor:</label>
                                <div class="col-xl-10">
                                    <select-with-validation
                                        vid="Sort"
                                        label="Sortering"
                                        v-model="user.Sort"
                                        component="user-sort-filter"
                                        hide-label
                                        rules="required"
                                        :reduce="(opt) => opt.id"
                                    ></select-with-validation>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <label class="col-form-label col-xl-2">Lösenord:</label>
                                <div class="col-xl-10">
                                    <div class="card">
                                        <div class="card-header bg-light">
                                            <h6 class="card-title">Nytt lösenord</h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <label class="col-form-label col-xl-2">Lösenord: <span class="text-danger">*</span></label>
                                                <div class="col-xl-10">
                                                    <ValidationProvider vid="password" name="Lösenord" rules="" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <input type="password" class="form-control" v-model="user.password" v-bind:class="{ 'border-danger':errors[0] }">
                                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <label class="col-form-label col-xl-2">Bekräfta: <span class="text-danger">*</span></label>
                                                <div class="col-xl-10">
                                                    <ValidationProvider vid="password_confirm" name="Bekräfta Lösenord" rules="confirmed:password" v-slot="{ errors }">
                                                        <div class="form-group">
                                                            <input type="password" class="form-control" v-model="user.password_confirm" v-bind:class="{ 'border-danger':errors[0] }">
                                                            <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="user.UserID > 0" class="row mt-4">
                                <label class="col-form-label col-xl-2">Senast inloggad:</label>
                                <div class="col-form-label col-xl-10 text-left">{{ formatDateTime(user.LastLoginTS) }}</div>
                            </div>
                        </div>
                    </div>
                </form>
            </ValidationObserver>

            <div class="d-flex justify-content-end">
                <limitless-button ref="btnsaveuser" type="button" @click="saveUser" :busy="busy_saving" icon="icon-floppy-disk">Save</limitless-button>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import { formatDateTime } from '@services/Helpers';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';

export default {
    components: {
        SelectWithValidation,
        LimitlessButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        busy_saving: false,
        not_found: false,
        user: null,
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        formatDateTime,
        init() {
            this.getUser();
        },
        getUser() {
            apiClient.get('/vue/users/' + this.id + '')
                .then((response) => {
                    this.user = response.data.user;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
        async saveUser() {
            const isValid = await this.$refs.userform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/users/' + this.id, this.user)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== response.data.user.UserID) {
                            window.location.href = '/users/' + response.data.user.UserID;
                        }
                        this.user = response.data.user;
                        this.$refs.btnsaveuser.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.userform.setErrors(parsederror);
                        }
                        this.$refs.btnsaveuser.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            }
        },
    },
};

</script>
